import { styled, Switch } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const CustomSwitchBase = (props) => {
  const theme = useTheme();
  return <Switch {...props} theme={theme} />;
};

const CustomSwitch = styled(CustomSwitchBase)(({ theme }) => ({
  width: 50,
  height: 28,
  padding: 5,
  '& .MuiSwitch-switchBase': {
    margin: 1,
    padding: 0,
    transform: 'translateX(4px)',
    '&.Mui-checked': {
      color: '#fff',
      transform: 'translateX(20px)',
      '& + .MuiSwitch-track': {
        backgroundColor: theme.palette.switch?.on || '#1976d2',
        opacity: 1,
        border: 0,
      },
    },
  },
  '& .MuiSwitch-thumb': {
    backgroundColor: '#fff',
    width: 24,
    height: 24,
    boxShadow: '0 2px 4px 0 rgba(0, 35, 11, 0.2)',
  },
  '& .MuiSwitch-track': {
    borderRadius: 14 / 2,
    backgroundColor: theme.palette.switch?.off || '#bdbdbd',
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 500,
    }),
  },
}));

export default CustomSwitch;